module.exports = __webpack_public_path__ + "img/LinkedIn.2ee39817.png";